import { Component, type CSSProperties } from 'react'
import RoundTimings from '../../../../screens/AccountsSettings/HomeSettings/components/RoundTimings'
import NextStepSection from '../components/NextStepSection'

interface MedTimesProps {
  deleteRoundTiming: () => void
  emarRoundTimings: any[]
  fields: any
  formId: string
  goToNextStep: () => void
  home?: { name?: string }
  openNewRoundTimingModal: () => void
  preferredPeopleNominative: string
}

export default class MedTimes extends Component<MedTimesProps> {
  render() {
    const {
      goToNextStep,
      openNewRoundTimingModal,
      deleteRoundTiming,
      emarRoundTimings,
      home = {}
    } = this.props

    return (
      <div style={styles.container as CSSProperties}>
        <div
          style={
            { ...styles.sectionContainer, marginBottom: 16 } as CSSProperties
          }
        >
          <div style={{ fontSize: 20 }}>Medication Times</div>
          <div style={{ width: '100%', border: '1px solid #DDDDDD' }} />
        </div>
        <div style={styles.topText}>
          Set up the times that {home.name || 'you'} do medication rounds. This
          option will appear when you are adding medications to the system,
          saving you time.
        </div>
        <div style={styles.sectionContainer as CSSProperties}>
          {!emarRoundTimings || !emarRoundTimings.length ? (
            <div className="lmc-card" style={styles.cardStyle as CSSProperties}>
              <img
                alt=""
                src="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/emar/marchart.png"
                style={{ maxHeight: 180 }}
              />
              <h2>No medication times yet</h2>
              <div style={styles.topText}>
                Add the usual hours for medication administation. Feel free to
                skip this section if you don’t have round times.
              </div>
            </div>
          ) : null}
          <RoundTimings
            deleteRoundTiming={deleteRoundTiming}
            openNewRoundTimingModal={openNewRoundTimingModal}
            roundTimings={emarRoundTimings}
            hideHeader
            homeName={undefined}
          />
        </div>
        <NextStepSection onNext={() => goToNextStep()} />
      </div>
    )
  }
}

const styles = {
  container: {
    position: 'relative',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    maxWidth: 960,
    height: '100%',
    padding: '16px',
    marginTop: 16
  },
  topText: {
    marginBottom: 32
  },
  bottomText: {
    marginTop: 32,
    fontSize: 12
  },
  sectionContainer: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  cardStyle: {
    // background: '#FFFFFF',
    // boxShadow: '0px 0px 8px rgba(34, 34, 34, 0.2)',
    // padding: 16,
    // borderRadius: 4,
    width: '100%',
    minHeight: 320,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 32
  }
}
